import React from "react";
import { Container, Row } from "react-bootstrap";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import "../Finance/Finance.css";
import DropDown from "../../../_components/_common/DropDown/DropDown";
import { CommonApiService } from "../../../_services/CommnService/CommonApiService";
import { Validation } from "../../../_helpers/validation/Validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import toastr from "toastr";
import { BuySellServices } from "../../../_services/BuySellServices/BuySellServices";
import { ServiceRequestServices } from "../../../_services/Warehouse/service-request-service";
import Loader from "../../../_components/_common/Loader/Loader";
import isLogin from "../../../_helpers/Common/helper";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import { multiLingual } from "../../../_components/Multilingualplaceholder/Multilingualplaceholder";
import { AryaPro } from "../../../_services/index";
import { Link } from "react-router-dom";
import { CommonVariables } from "../../../_constants/CommonVariables";
class CommodityMarketPlace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      content: "",
      subtitle: "",
      radioData: [],
      stateArray: [],
      state: "",
      district: "",
      cityArray: [],
      isloading: false,
      commodity: "",
      file_name: "",
      Variety: "",
      Stock_Number: "",
      Quantity: "",
      Indicative_Price: "",
      funded_unfunded: "1",
      Quality_Certified: "1",
      commodity_stored_with_arya: "2",
      remarks: "",
      parameters: [],
      whList: [],
      warehouse: "",
      type: 1,
      error: {},
      isWareHouse: false,
      userDashBoradData: {},
      quantity_to_be_traded: "",
      whid: "",
      userForm: false,
      placeholderMultilingual: "",
      stateName: "",
      cityName: "",
      lat: "",
      long: "",

      aryaProWhName: "",
      warehouse_code: "",
      commodity_name: "",
    };

    this.getCityOfState = this.getCityOfState.bind(this);
    this.onchangeState = this.onchangeState.bind(this);
    this.onchangeLocation = this.onchangeLocation.bind(this);
    this.onchangeComodity = this.onchangeComodity.bind(this);
    this.errorReset = this.errorReset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChamgeWarehouse = this.onChamgeWarehouse.bind(this);
    this.getAllRequiredDataFromServer =
      this.getAllRequiredDataFromServer.bind(this);
  }
  async componentDidMount() {
    setInterval(() => {
      if (multiLingual()["Warehouse"] !== this.state.placeholderMultilingual) {
        this.setState({
          placeholderMultilingual: multiLingual()["Warehouse"],
        });
      }
    }, 2000);
    let type = "";
    if (this.props.type) {
      type = this.props.type;
    } else {
      type = localStorage.getItem("typeOf");
    }

    this.setState(
      {
        type: parseInt(type),
        userDashBoradData: JSON.parse(
          localStorage.getItem("userDashBoardData")
        ),
      },
      async () => {
        if (parseInt(type) === 1) {
          localStorage.setItem("kycMessage", "To Continue With Buy Commodity");
          this.setState({
            file_name: "",
            Stock_Number: "",
            funded_unfunded: "",
            Quality_Certified: "",
            commodity_stored_with_arya: "",
          });
        } else {
          localStorage.setItem("kycMessage", "To Continue With Sell Commodity");
        }

        if (this.props.whid) {
          await this.getAllRequiredDataFromServer();
          this.setState(
            {
              warehouse: this.props.whid,
              commodity_stored_with_arya: "1",
              userForm: true,
            },
            () => {
              Array.isArray(this.state.whList) &&
                this.state.whList.map((data, index) => {
                  if (parseInt(data.value) === parseInt(this.state.warehouse)) {
                    this.setState(
                      {
                        state: data.warehouse_state,
                        district: data.warehouse_city,
                        isWareHouse: true,
                        commodity: data.commodity,
                        Quantity: data.Quantity,
                      },
                      () => {
                        this.getCityOfState(this.state.state);
                      }
                    );
                  }
                  return true;
                });
            }
          );
        } else {
          this.isThisHaveStates();
        }
      }
    );

    this.apiStateAndDistrict();
  }

  async componentDidUpdate(prev) {
    let type = "";
    if (this.props.type) {
      type = this.props.type;
    } else {
      type = localStorage.getItem("typeOf");
    }

    if (parseInt(type) !== this.state.type) {
      this.setState(
        {
          type: parseInt(type),
        },
        () => {
          if (type === 1) {
            this.setState({
              file_name: "",
              Stock_Number: "",
              funded_unfunded: "",
              Quality_Certified: "",
              commodity_stored_with_arya: "",
            });
          } else {
          }
        }
      );
      console.log("ssss1");
      this.apiStateAndDistrict();
    }
  }

  isThisHaveStates = () => {
    let data = JSON.parse(localStorage.getItem("BuySellAllStates"));
    if (data !== null && data !== "") {
      if (parseInt(this.state.type) === 2) {
        this.setState(
          {
            Indicative_Price: data.Indicative_Price,
            Quantity: data.Quantity,
            Variety: data.Variety,
            cityArray: data.cityArray,
            commodity: data.commodity,
            commodity_stored_with_arya: data.commodity_stored_with_arya
              ? data.commodity_stored_with_arya
              : "2",
            district: data.district,
            remarks: data.remarks,
            selected_warehouse_id: data.selected_warehouse_id,
            state: data.state,
            warehouse: data.warehouse,
            quantity_to_be_traded: data.quantity_to_be_traded,
          },
          () => {
            if (this.state.commodity_stored_with_arya === "1") {
              if (isLogin()) {
                this.getAllRequiredDataFromServer();
                this.setState({
                  isWareHouse: true,
                });
              } else {
                this.reset();
              }
            }
          }
        );
      } else {
        this.setState({
          Indicative_Price: data.Indicative_Price,
          Quantity: data.Quantity,
          Variety: data.Variety,
          cityArray: data.cityArray,
          commodity: data.commodity,
          // commodity_stored_with_arya: data.commodity_stored_with_arya,
          district: data.district,
          remarks: data.remarks,
          state: data.state,
          quantity_to_be_traded: data.quantity_to_be_traded,
        });
      }
    }
  };

  async getAllRequiredDataFromServer() {
    let stockRes = await AryaPro.clientwisestock();
    let usertype = await localStorage.getItem("aryauserType");
    let response;
    if (parseInt(this.state.type) === 2 && parseInt(usertype) === 6) {
      response = await ServiceRequestServices.getAllOwnerWarehouseList();
    } else if (parseInt(this.state.type) === 2) {
      response =
        await ServiceRequestServices.getAllWarehouseForserviceRequest();
    }
    let list = [];
    if (response && response.data.data && response.data.data.length > 0) {
      response.data.data.map((obj, index) => {
        stockRes &&
          stockRes.data &&
          Array.isArray(stockRes.data.data) &&
          stockRes.data.data.map((stock) => {
            if (stock.warehouse_code === obj.warehouse_code) {
              list.push({
                label: obj.name,
                value: obj.warehouse_id,
                warehouse_state: obj.warehouse_state,
                warehouse_city: obj.warehouse_city,
                commodity: stock.commodity_id,
                Quantity: stock.MT ? parseFloat(stock.MT) : 0,
                check: true,
                aryaProWhName: stock.warehouse_name,
                warehouse_code: stock.warehouse_code,
                commodity_name: stock.commodity_name,
              });
            }
            return true;
          });
        return true;
      });
    }
    this.setState({
      whList: Object.assign([], list),
    });
  }

  Constants() {
    if (this.state.type === 1) {
      return [
        {
          field_name: "district",
          label: "Location",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "commodity",
          label: "Commodity",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "state",
          label: "State",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "quantity",
          label: "Quantity",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "Variety",
          label: "Variety",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "Quantity",
          label: "Quantity",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "quantity_to_be_traded",
          label: "Quantity To Be Traded",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "Indicative_Price",
          label: "Indicative Price",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
      ];
    } else {
      return [
        {
          field_name: "warehouse",
          label: "Warehouse",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "district",
          label: "Location",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "commodity",
          label: "Commodity",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "state",
          label: "State",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "quantity",
          label: "Quantity",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "Variety",
          label: "Variety",
          type: "string",
          isRequired: true,
        },
        {
          field_name: "Quantity",
          label: "Quantity",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "quantity_to_be_traded",
          label: "Quantity To Be Traded",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
        {
          field_name: "Indicative_Price",
          label: "Indicative Price",
          type: "number",
          isNonNegative: true,
          isRequired: true,
        },
      ];
    }
  }

  onErrorReset() {
    if (this.state.isClicked) {
      const field = this.Constants();
      var errobj = {};
      errobj = Validation(this.state, field);
      this.setState({
        error: errobj,
      });
    }
  }

  apiStateAndDistrict() {
    CommonApiService.getStatesOfCountry().then((response) => {
      if (response && response.data && response.data.data)
        this.setState({
          stateArray: response.data.data,
        });
    });
  }

  onchangeState(e) {
    this.setState(
      {
        state: e.value,
        district: null,
        isloading: true,
        stateName: e.label,
      },
      () => {
        this.getCityOfState(this.state.state);
        this.onErrorReset();
      }
    );
  }

  getCityOfState(id, getLetLong) {
    CommonApiService.getCityOfState(id).then((response) => {
      this.setState(
        {
          cityArray: response.data.data,
          isloading: false,
        },
        () => {
          if (getLetLong) getLetLong();
        }
      );
    });
  }

  onchangeLocation(e) {
    this.setState(
      {
        district: e.value,
        selected_warehouse_id: "",
        cityName: e.label,
      },
      async () => {
        this.getLetLong();
        this.onErrorReset();
      }
    );
  }

  getLetLong = async () => {
    let location = "";
    Array.isArray(this.state.stateArray) &&
      this.state.stateArray.map((x) => {
        if (parseInt(this.state.state) === parseInt(x.value)) {
          location = location + x.label;
        }
        return true;
      });
    Array.isArray(this.state.cityArray) &&
      this.state.cityArray.map((x) => {
        if (parseInt(this.state.district) === parseInt(x.value)) {
          location = `${location} ${x.label} india`;
        }
        return true;
      });
    let response = await BuySellServices.getLatlong(location);

    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.data
    ) {
      let data = response.data.data;
      this.setState({
        lat: data.lat,
        long: data.long,
      });
    }
  };

  onchangeComodity(e) {
    this.setState(
      {
        commodity: e.value,
      },
      () => {
        this.onErrorReset();
      }
    );
  }

  errorReset() {
    this.setState({
      error: {},
    });
  }

  onChange(e) {
    let name = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (name === "commodity_stored_with_arya") {
          if (isLogin()) {
            this.resetonComodity();
            this.setState({
              warehouse: "",
            });
            if (parseInt(this.state.commodity_stored_with_arya) === 2) {
              this.setState({
                isWareHouse: false,
              });
            } else {
              this.getAllRequiredDataFromServer();
            }
          } else {
            this.setState({
              [name]: "2",
            });
            if (this.props.redirectLogin) {
              this.props.redirectLogin(
                "Please Login/Signup to access this page."
              );
            }
          }
        }
        this.onErrorReset();
      }
    );
  }

  onChamgeWarehouse(e) {
    this.setState(
      {
        warehouse: e.value,
        state: e.warehouse_state,
        district: e.warehouse_city,
        isWareHouse: true,
        commodity: e.commodity,
        Quantity: e.Quantity,
        aryaProWhName: e.aryaProWhName,
        warehouse_code: e.warehouse_code,
        commodity_name: e.commodity_name,
      },
      async () => {
        await this.getCityOfState(this.state.state, this.getLetLong);
        this.onErrorReset();
      }
    );
  }

  onSubmit = async (e) => {
    e.preventDefault();
    if (
      parseInt(this.state.Quantity) < parseInt(this.state.quantity_to_be_traded)
    ) {
      toastr.info("Not in Stock");
      return false;
    }
    const field = this.Constants();
    var errobj = {};
    let flag = 0;
    errobj = Validation(this.state, field);
    this.setState(
      {
        error: errobj,
        isloading: true,
        isClicked: true,
      },
      async () => {
        field.forEach((obj, index) => {
          let key = obj.field_name;
          if (
            this.state.error[key] !== "" &&
            this.state.error[key] !== undefined
          ) {
            flag = 1;
          }
         
        });
        if (flag === 0) {
          let commodity_id = "";
          if (
            this.state.type === 2 &&
            parseInt(this.state.commodity_stored_with_arya) === 1
          ) {
            let commoRes = await AryaPro.comodityIdByName(this.state.commodity);
            if (
              commoRes &&
              commoRes.data &&
              commoRes.data.data &&
              commoRes.data.data.commodity_id
            ) {
              commodity_id = commoRes.data.data.commodity_id;
            } else {
              toastr.info("Commodity not Found");
              return false;
            }
          }

          this.setState({ isloading: true });
          let data = {
            type: this.state.type,
            commodity_with_arya:
              this.state.type === 1
                ? ""
                : this.state.commodity_stored_with_arya,
            warehouse:
              this.state.type === 1
                ? ""
                : parseInt(this.state.commodity_stored_with_arya) === 2
                ? this.state.warehouse
                : this.state.aryaProWhName,
            commodity:
              this.state.type === 1 ||
              parseInt(this.state.commodity_stored_with_arya) === 2
                ? this.state.commodity
                : commodity_id,
            quantity: this.state.quantity_to_be_traded,
            indicative_price: this.state.Indicative_Price,
            quantity_to_be_traded: this.state.Quantity,
            variety: this.state.Variety,
            location: this.state.district,
            state: this.state.state,
            stock_service_number: this.state.Stock_Number,
            funded_unfunded:
              this.state.type === 1 ? "" : this.state.funded_unfunded,
            arya_certified:
              this.state.type === 1 ? "" : this.state.Quality_Certified,
            remark: this.state.remarks,
            multimedia_id:
              this.state.type === 1 || this.state.file_name === ""
                ? ""
                : [this.state.file_name],
            parameters: this.state.parameters,
            lat: this.state.lat,
            long: this.state.long,
            buysell_lat: this.state.lat,
            buysell_long: this.state.long,
            warehouse_code: this.state.warehouse_code,
          };

          var apiresponse = "";

          if (isLogin()) {
            if (this.state.isEdit) {
              apiresponse = await BuySellServices.saveBuySell(
                this.state.id,
                data
              );
            } else {
              apiresponse = await BuySellServices.saveBuySell(data);
            }
            this.setState({ isloading: false });
            if (apiresponse) {
              this.reset();
              toastr.success("Quote Submitted!");
              this.props.history.push("/quote-requested-successful");
            }
          } else {
            toastr.warning("To Submit Buy Sell Form Please Login/Signup First");
            this.setState({ isloading: false });
          }
        } else {
          this.setState({ isloading: false });
        }
      }
    );
  };

  reset() {
    this.setState({
      title: "",
      content: "",
      subtitle: "",
      radioData: [],
      stateArray: [],
      state: "",
      district: "",
      cityArray: [],
      isloading: false,
      commodity: "",
      file_name: "",
      Variety: "",
      Stock_Number: "",
      Quantity: "",
      Indicative_Price: "",
      funded_unfunded: "1",
      Quality_Certified: "1",
      commodity_stored_with_arya: "2",
      remarks: "",
      parameters: [],
      whList: [],
      warehouse: "",
      type: 1,
      error: {},
      isWareHouse: false,
      userDashBoradData: {},
      quantity_to_be_traded: "",

      aryaProWhName: "",
      warehouse_code: "",
      commodity_name: "",
    });
  }

  resetonComodity = () => {
    this.setState({
      title: "",
      content: "",
      subtitle: "",
      radioData: [],
      stateArray: [],
      state: "",
      district: "",
      cityArray: [],
      isloading: false,
      commodity: "",
      file_name: "",
      Variety: "",
      Stock_Number: "",
      Quantity: "",
      Indicative_Price: "",
      funded_unfunded: "1",
      Quality_Certified: "1",
      // commodity_stored_with_arya: "2",
      remarks: "",
      parameters: [],
      whList: [],
      warehouse: "",
      type: 1,
      error: {},
      isWareHouse: false,
      userDashBoradData: {},
      quantity_to_be_traded: "",
      aryaProWhName: "",
      warehouse_code: "",
      commodity_name: "",
    });
  };

  redirectLogin = (toastrMessage) => {
    if (this.props.redirectLogin) {
      this.props.redirectLogin("Please Login/Signup to access this page.");
    }
    // toastr.error(toastrMessage ? toastrMessage : "Please Login/Signup to access this page.")
    //this.props.history.push('/login');
  };

  componentWillUnmount() {
    localStorage.setItem("BuySellAllStates", JSON.stringify(this.state));
  }

  render() {
    let usertype = localStorage.getItem("aryauserType");
    const commodity = this.props.option.options_master.commodity;
    return (
      <React.Fragment>
        <SetHeader
          active={"management"}
          history={this.props.history}
        ></SetHeader>
        <Loader loading={this.state.isloading}></Loader>

        <section className="leaveusMsg-bx buySell-leaveUs-bx new-commodities">
          <Container>
            <Row>
              <div className="col-sm-12 col-md-8">
                <form onSubmit={this.onSubmit.bind(this)}>
                  <h2>
                    {parseInt(this.state.type) === 1 ? (
                      <>
                        <MultiLanguageTranslation
                          title={"Did not find what you are looking for?"}
                        ></MultiLanguageTranslation>
                        <MultiLanguageTranslation
                          title={"Leave_us_message_and_we_will_get_back"}
                        ></MultiLanguageTranslation>
                      </>
                    ) : (
                      <MultiLanguageTranslation
                        title={"Wish to Sell Commodity?"}
                      ></MultiLanguageTranslation>
                    )}
                  </h2>
                  <br></br>
                  <div className="selectBoxHeight serviceReqbx_all">
                    <div className="">
                      <div className="form-group">
                        <label className="w-100">
                          {" "}
                          {this.state.type === 2 ? (
                            <MultiLanguageTranslation
                              title={"Sell Commodity in a hassle-free way"}
                            ></MultiLanguageTranslation>
                          ) : (
                            <MultiLanguageTranslation
                              title={"Buy Commodity in a hassle-free way"}
                            />
                          )}
                        </label>
                      </div>
                    </div>
                    {this.state.type === 2 && !this.state.userForm && (
                      <div className="commodity-store">
                        <div className="form-group">
                          <div className="d-flex justify-content-between commodity-store-section">
                            <div className="form-group">
                              <label className="w-100">
                                <MultiLanguageTranslation
                                  title={"Commodity Stored with Arya"}
                                />
                              </label>
                            </div>
                            <div className="d-flex">
                              <Form.Check
                                custom
                                type="radio"
                                id="custom-switchgcal_certy13"
                                label={
                                  <MultiLanguageTranslation title={"Yes"} />
                                }
                                name="commodity_stored_with_arya"
                                checked={
                                  parseInt(
                                    this.state.commodity_stored_with_arya
                                  ) === 1
                                    ? true
                                    : false
                                }
                                onChange={this.onChange.bind(this)}
                                value="1"
                                style={{ marginRight: "55px" }}
                              />
                              <Form.Check
                                custom
                                type="radio"
                                id="custom-switchgcal_certy23"
                                label={
                                  <MultiLanguageTranslation title={"No"} />
                                }
                                name="commodity_stored_with_arya"
                                checked={
                                  parseInt(
                                    this.state.commodity_stored_with_arya
                                  ) === 2
                                    ? true
                                    : false
                                }
                                onChange={this.onChange.bind(this)}
                                value="2"
                                style={{ marginRight: "55px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="sell-comm">
                      {this.state.type === 2 && (
                        <div className="sell-comm-group form-group">
                          <label className="w-100">
                            <MultiLanguageTranslation title={"Warehouse"} />
                            <sup>*</sup>
                          </label>
                          {parseInt(this.state.commodity_stored_with_arya) ===
                          1 ? (
                            <DropDown
                              preselected={this.state.warehouse}
                              options={this.state.whList}
                              onChange={this.onChamgeWarehouse}
                              isDisabled={this.state.userForm}
                            />
                          ) : (
                            <input
                              type="text"
                              onChange={(e) => this.onChange(e)}
                              name="warehouse"
                              value={this.state.warehouse}
                              placeholder={multiLingual()["Warehouse"]}
                            />
                          )}

                          {this.state.error &&
                            this.state.error.warehouse !== "" && (
                              <div className="fromerror">
                                {this.state.error.warehouse}
                              </div>
                            )}
                        </div>
                      )}
                      <div className="sell-comm-group form-group inputserviceReqbx">
                        <label className="w-100">
                          <MultiLanguageTranslation title={"state"} />
                          <sup>*</sup>
                        </label>
                        {this.state.stateArray && (
                          <DropDown
                            preselected={this.state.state}
                            options={this.state.stateArray}
                            onChange={this.onchangeState}
                            isDisabled={this.state.isWareHouse}
                          />
                        )}
                        {this.state.error.state !== "" && (
                          <div className="fromerror">
                            {this.state.error.state}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="sell-comm">
                      <div className="sell-comm-group form-group inputserviceReqbx">
                        <label className="w-100">
                          {" "}
                          <MultiLanguageTranslation title={"Location"} />
                          <sup>*</sup>
                        </label>
                        {this.state.stateArray && (
                          <DropDown
                            preselected={this.state.district}
                            options={this.state.cityArray}
                            onChange={this.onchangeLocation}
                            isDisabled={this.state.isWareHouse}
                          />
                        )}
                        {this.state.error.district !== "" && (
                          <div className="fromerror">
                            {this.state.error.district}
                          </div>
                        )}
                      </div>
                      <div className="sell-comm-group form-group inputserviceReqbx">
                        <label className="w-100">
                          <MultiLanguageTranslation title={"Commodity"} />
                          <sup>*</sup>
                        </label>
                        {parseInt(this.state.commodity_stored_with_arya) ===
                        1 ? (
                          <>
                            <input
                              type="text"
                              name="warehouse"
                              value={this.state.commodity_name}
                            />
                          </>
                        ) : (
                          <>
                            {commodity && (
                              <DropDown
                                className="customSelect"
                                preselected={this.state.commodity}
                                options={commodity}
                                onChange={this.onchangeComodity}
                                isDisabled={this.state.isWareHouse}
                              />
                            )}
                            {this.state.error &&
                              this.state.error.commodity !== "" && (
                                <div className="fromerror">
                                  {this.state.error.commodity}
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    </div>

                    <div className="sell-comm">
                      <div className="sell-comm-group form-group">
                        <label className="w-100">
                          <MultiLanguageTranslation title={"Variety"} />
                          <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          placeholder={multiLingual()["Variety"]}
                          name="Variety"
                          onChange={this.onChange}
                          value={this.state.Variety}
                        />

                        {this.state.error &&
                          this.state.error.Variety !== "" && (
                            <div className="fromerror">
                              {this.state.error.Variety}
                            </div>
                          )}
                      </div>
                      <div className="sell-comm-group form-group">
                        <label className="w-100">
                          {multiLingual()["Quantity(MT)"]}
                          <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          placeholder={multiLingual()["Quantity(MT)"]}
                          name="Quantity"
                          onChange={this.onChange}
                          value={this.state.Quantity}
                          readOnly={this.state.isWareHouse}
                        />

                        {this.state.error &&
                          this.state.error.Quantity !== "" && (
                            <div className="fromerror">
                              {this.state.error.Quantity}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="sell-comm">
                      <div className="sell-comm-group form-group">
                        <label className="w-100">
                          <MultiLanguageTranslation
                            title={"Indicative Price Per MT (*Negotiable)"}
                          />
                          <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          placeholder={
                            multiLingual()["Indicative Price Per MT"]
                          }
                          name="Indicative_Price"
                          onChange={this.onChange}
                          value={this.state.Indicative_Price}
                        />
                        {this.state.error &&
                          this.state.error.Indicative_Price !== "" && (
                            <div className="fromerror">
                              {this.state.error.Indicative_Price}
                            </div>
                          )}
                      </div>
                      <div className="sell-comm-group form-group">
                        <label className="w-100">
                          <MultiLanguageTranslation
                            title={"Quantity To Be Traded"}
                          />
                          <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          placeholder={multiLingual()["Quantity To Be Traded"]}
                          name="quantity_to_be_traded"
                          onChange={this.onChange}
                          value={this.state.quantity_to_be_traded}
                        />
                        {this.state.error &&
                          this.state.error.quantity_to_be_traded !== "" && (
                            <div className="fromerror">
                              {this.state.error.quantity_to_be_traded}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="sell-comm">
                      <div className="BuyselcommSubmit">
                        {isLogin() ? (
                          // <PermissibleRender
                          //     userPermissions={permissions}
                          //     requiredPermissions={["allow-booking"]} >
                          <>
                            {parseInt(usertype) === 1 ||
                            parseInt(usertype) === 2 ? (
                              <Link
                                id={
                                  this.state.type === 2
                                    ? "sell_buy_sell"
                                    : "buy_buy_sell"
                                }
                                disabled={parseInt(this.state.Quantity) === 0}
                                onClick={(e) =>
                                  toastr.warning(
                                    "Super admin or Sub admin can't submit"
                                  )
                                }
                                type="submit"
                                className="primaryP"
                              >
                                <MultiLanguageTranslation title={"Submit"} />
                              </Link>
                            ) : (
                              <Link
                                id={
                                  this.state.type === 2
                                    ? "sell_buy_sell"
                                    : "buy_buy_sell"
                                }
                                disabled={parseInt(this.state.Quantity) === 0}
                                onClick={(e) => this.onSubmit(e)}
                                type="submit"
                                className="primaryP"
                              >
                                <MultiLanguageTranslation title={"Submit"} />
                              </Link>
                            )}
                          </>
                        ) : (
                          // </PermissibleRender>
                          <Link
                            id={
                              this.state.type === 2
                                ? "sell_buy_sell"
                                : "buy_buy_sell"
                            }
                            type="submit"
                            className="primaryP"
                            onClick={() =>
                              this.redirectLogin(
                                "To Submit Buy Sell Form Please Login/Signup First"
                              )
                            }
                          >
                            <MultiLanguageTranslation title={"Submit"} />
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-md-1 d-xs-none">
                <div className="seperator-sell">
                  <span>OR</span>
                </div>
              </div>
              <div className="col-sm-12 col-md-3">
                <div class="Pbuysell-contact">
                  <div class="pbuysell-contact-heading">
                    <h3>
                      <MultiLanguageTranslation title="Contact Us At" />:
                    </h3>
                  </div>
                  <div class="pbuysell-contact-content">
                    <div class="pbuysell-contact-links">
                      <div class="plink-op">
                        <img
                          alt=""
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgB7ZXdEYIwEIRXK0gJsQM6UCvQEtKBWoFagXagHThW4FiBJUgHagV4J8cMBMKfYYYHvpl9gORuwyYAMNB3RiRDmqJbrmwUycWeFMIvAWlFekOMDOlFWsMfbPCU3lFixGgZOJEU2qOkx0N6/jzGqQkhaUL6WJOaEEgt95jD2oqooMCgeZTpqGwy0dlo1IuyKKqc0bikQYjqKEujyrnBvdIEg3yUdlSqysNl9EA2by2NbyL7KY3cb2S0JV0cRUvSzDHGNYe6Rkkkbd4lJbXrKqNAJmq0RyPez8BlpMVkif+ZIbvgjBEP7OCPHeIDo9JGvIFH+OcsvSP+TbzEdQP5nHuE+/IJVmzEe7JAt9wx0Hu+JFpT7RCqEoUAAAAASUVORK5CYII="
                        />
                        <span>
                          <a href={"mailto:" + CommonVariables.arya_email}>
                            {CommonVariables.arya_email}
                          </a>
                        </span>
                      </div>
                      <div class="plink-op">
                        <img
                          alt=""
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGOSURBVHgBrVXBcYQwDNzMNUAJLoES/MzzOoifefLM79JB6AA6SAmUcHkmL0q4SQXEOuQgjMDmhp3R+PBptZIt2yc8hqu3N2+ltydv31vOp+ibSK/ejLevDd4PB39mf+ftN8G548Xb4O3GI2VbIA3rrWNOs8UJAi07lSyWK0RwzOkxrsQMRghIbAk5jBVosXq2GafjSQ1BqBNzBfsPPF4UIeJ8yklyfsc6LPuUSgIt9P2reN7miriYoCQRVwtEK0Q/mpUA5UoATYgSqZQ5GlFzoBhn7Ouwlv2lb8/x54oJ0hasEqeGWDLKtlshVcgHBXRRjP+4Dno11IZUjUEeklWT4lUhhcNlcAAsxmo+onmDqQHMBtciEzX0ZaNW1ioqWHxg65DZKOSo7YNhEfrPCYEbJxVOeVbLG6zvA323InMSkNeNO0oInHmD5X0mhVK3xEKoxD44FjrnOBtMG3tBPgz2H+T7LR3eD5vwlQ1hsBMG02PVrYhJgb1LPIPD/GWkBqjYDhGQsBjbOexZeHcWAn9ZvY8O9lqZQgAAAABJRU5ErkJggg=="
                        />

                        <span>
                          <a href="tel:+919015260260">+91 90152 60260</a>
                        </span>
                      </div>
                    </div>
                    <p>
                      <MultiLanguageTranslation title="buysellform_page_title_For_trading_enquiries" />
                    </p>
                  </div>
                </div>
              </div>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {};

function mapStateToProps(state) {
  const { userDataCache } = state.userData;
  const { option } = state;
  return {
    userDataCache,
    option,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CommodityMarketPlace));
